import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const editorAvatar = css`
  margin-right: 8px;
`;
export const commentsWrapper = css`
  margin: 0;
  margin-top: 16px;
  margin-bottom: -6px;

  .ant-list-item {
    padding-top: 6px;
    padding-bottom: 6px;
    position: relative;
    z-index: 1;
  }
  .ant-list-item:focus-within {
    z-index: 10;
  }
  .ant-list-item > .animated {
    animation-fill-mode: none !important;
  }
  .ant-list-empty-text {
    display: none;
  }
  .ant-spin {
    position: static !important;
    padding: 24px 0;
  }
  .ant-spin .ant-spin-dot {
    position: static !important;
    margin: 0 !important;
  }
`;

export const BorderComments = styled.div`
  border-top: 1px ridge ${({ theme }) => theme.colors.gray4};
`;
export const CommentsContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 40px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 0 0 8px 8px;
  overflow: visible;

  .animated {
    animation-fill-mode: none !important;
  }
`;
export const AvatarWrapper = styled.div`
  float: left;
  width: 85px;
`;
export const EditorWrapper = styled.div`
  float: left;
  width: 100%;
`;
